<template>
  <div class="card mt-4 p-4">
    <div class="progress lg-progress-bar">
      <div role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="50"
           class="progress-bar bg-success progress-bar-striped"
           :style="{ width: Math.round((finishedSteps / allSteps) * 100) + '%'}">
        {{ Math.round((finishedSteps / allSteps) * 100) }}%
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modules: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  created() {

    this.modules.forEach((record) => {

      if (record.items && record.items.length) {
        record.items.forEach((section) => {
          if (section.items && section.items.length) {
            section.items.forEach((row) => {

              row.steps.forEach((data) => {

                this.allSteps++


                if (data.project_steps.is_active == 3) {

                  this.finishedSteps++
                }
              })
            })
          }
        })
      }
    })

  },
  data() {
    return {
      allSteps: 0,
      finishedSteps: 0
    };
  },
}

</script>